/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import React, { useRef } from 'react';
import styled from 'styled-components';
import { useInViewEffect } from '@oneaudi/feature-app-utils';
import CarGroup from '../CarGroup/CarGroup';
import Carline from '../CarLine/Carline';
import { useInitialState } from '../../context/InitialStateContext';
import { useTrackingManager } from '../../context/useTrackingManager';
import { Filter } from '../Filter/Filter';
import { useAppContext } from '../../context/Context';
import { handleSubmenuFocus } from '../../utils/a11y';

const LeanMoxxView: React.FC = () => {
  const { carlineGroups } = useInitialState();
  const trackingManager = useTrackingManager();
  const { carlineCardMenuRef, containerRef, filterContainer } = useAppContext();

  useInViewEffect(() => {
    if (carlineGroups) {
      trackingManager.impression();
    }
  });
  const triggerButtonRef = useRef<HTMLButtonElement | null>(null);

  const handleKeyDown = (event: KeyboardEvent) => {
    const isTriggerButton = (event.target as HTMLElement)?.dataset.trigger === 'true';

    const isFilterButton = (event.target as HTMLElement)?.id === 'filterTag';
    const isVtpTextLink = (event.target as HTMLElement)?.id === 'vtpTextLink';

    if (event.key === 'Escape' && (isFilterButton || isTriggerButton)) {
      const firstFocusableElement = filterContainer.current?.querySelector<HTMLElement>('div');
      firstFocusableElement?.focus();
    } else if (event.key === 'Escape' && !isVtpTextLink) {
      if (carlineCardMenuRef?.current?.contains(document.activeElement) && triggerButtonRef) {
        triggerButtonRef.current?.focus();
      }
    }
    if (event.key === 'Enter' && isTriggerButton) {
      const target = event.target as HTMLButtonElement;
      triggerButtonRef.current = target;
      handleSubmenuFocus(carlineCardMenuRef, target, 30);
    }

    if (event.key === 'Enter' && isFilterButton) {
      const target = event.target as HTMLButtonElement;
      triggerButtonRef.current = target;
      handleSubmenuFocus(containerRef, target, 30);
    }
  };

  return (
    <Layout>
      <Filter onKeyDown={handleKeyDown} />
      <CarGroup />
      <Carline onKeyDown={handleKeyDown} />
    </Layout>
  );
};

const Layout = styled.div`
  display: flex;
  flex-direction: column;
  margin: var(--spacing-relative-xl) auto;
  position: relative;
`;

export default LeanMoxxView;
